import React, { useContext } from 'react';
import {
	ICreateSubcategoryModalContext,
	CreateSubcategoryModalContext,
} from '../../../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';
import MainInfo from './components/MainInfo/MainInfo';
import Translations from './components/Translations/Translations';
import style from './CreateSubcategoryModalForm.module.scss';

const CreateSubcategoryModalForm: React.FC = () => {
	const { visibleForm } = useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);

	return (
		<div className={style.container} data-test="CreateSubcategoryModalForm">
			<MainInfo isVisible={visibleForm === 'mainForm'} />
			<Translations isVisible={visibleForm === 'translations'} />
		</div>
	);
};

export default CreateSubcategoryModalForm;
